import callApi from './crmService';
import callBackendApi from '../backendService/backendService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/binding`;

export const checkBinding = () => callApi({
    method: 'POST',
    endpoint: `${basePath}/check-binding`
  });

export const sendSmsValidate = (mobile_info) => callApi({
    method: 'POST',
    endpoint: `${basePath}/send-sms-validate`,
    body: mobile_info
  });

export const validateSmsAndBinding = (validate_info) => callApi({
    method: 'POST',
    endpoint: `${basePath}/validate-sms-and-binding`,
    body: validate_info
  });

  export const sendSmsValidateWithAreaCode = (info) => callApi({
    method: 'POST',
    endpoint: `${basePath}/send-sms-validate`,
    body: info
  });

export const checkMemberBind = (info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/check-member-bind`,
  body: info
});

export const getOneToOneInfo = () => callBackendApi({
  method: 'GET',
  endpoint: `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/one-to-one-info`
});

export const fastBindingCheck = (info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/one-key-binding-check`,
  body: info
});

export const fastBinding = (info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/one-key-binding`,
  body: info
});